import { SidebarMenuItem } from "Areas/Sidebar/Common";
import { documentTypeIconMap } from "Common/dictionaries/documentType";
import map from "lodash/map";
export const buildDocumentKey = (docId) => `document_${docId}`;
export default (documents, renderMenu) => map(documents, d => {
    const e = new SidebarMenuItem(buildDocumentKey(d.Id), d.Name, documentTypeIconMap[d.Type], undefined, d);
    e.useDotIcon = false;
    e.actionElements = renderMenu ? [renderMenu(d)] : undefined;
    return e;
});
